import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('CYBER_HEX', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  for (let i = 0; i < 6; i++) {
    const angle = (i / 6) * Math.PI * 2 + progress;
    const dist = progress * 80;
    const size = 15 * (1 - progress);
    const cx = e.pos.x + Math.cos(angle) * dist;
    const cy = e.pos.y + Math.sin(angle) * dist;

    ctx.strokeStyle = determineColor(i, 6);
    ctx.lineWidth = 2;
    ctx.globalAlpha = 1 - progress;
    ctx.beginPath();
    for (let j = 0; j < 6; j++) {
      const ja = (j / 6) * Math.PI * 2;
      ctx.lineTo(cx + Math.cos(ja) * size, cy + Math.sin(ja) * size);
    }
    ctx.closePath(); ctx.stroke();
  }
});
